var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_88_2",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_88_2",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAN2AAADdgF91YLMAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAD9QTFRF////QJ//N5b/N5f/MUdgN5f/MkdhM0hgOJf/OJj/RGCAMkdgRGCAM0lhMUlgRGCAMklgRGCAMkhgOJf/RGCAqUw0UwAAABJ0Uk5TAAguWF1dbHiAiLDIyNPo6O7uoDdlqwAAAQlJREFUeNrt2lkOwjAMRVFmzDyE/a+VDwbRJpFoI/kJfO8KzkfVOk4nEyIiIqLwnRo7H7NWgwC3xq55awAAAAAAAABAE+CyH9Zhl7VoAmy9JyIAQQBTUwOSqQFVgRugJvADVASOgLLAE1AUuAJKAl9AQeAMyAXegEzgDugL/AE9gQDQFSgAHYEE8CkYD5jNv2+ZqoLxgE1qydSAt0AGeAl0gKdACHgIlIBkakAyNSBZdIAFfwgt+IvIgn+M7A8GEvlI9sNDqXosVx9M1Ecz9eFUfTxXLyjUKxr1kkq9plMvKtWrWvWyWr2uV19YyK9sAAwAyK9uuT0HAAAAAAAA3AHyX7uJiIiIwncHDnOALua7zEwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.c8992b701e22cddfc6a3ea68b195be54.svg";
export { ForwardRef as ReactComponent };